import r from "react-dom/client";
import c from "react";
class i extends HTMLElement {
  constructor(t, e, o = {}, n) {
    super(), this.jsx = t, this.styles = e, this.root = this.attachShadow({ mode: "open" }), this.reactRoot = null, this.fullHeight = n?.fullHeight ?? !1, o && (this.props = o);
  }
  connectedCallback() {
    const t = document.createElement("div");
    t.style.minHeight = "1px", t.style.width = "100%", t.style.height = this.fullHeight ? "100%" : "auto";
    const e = document.createElement("style");
    e.innerText = this.styles, this.root.appendChild(t), this.root.appendChild(e), this.reactRoot = r.createRoot(t), this.renderReact();
  }
  disconnectedCallback() {
    this.reactRoot && this.reactRoot.unmount();
  }
  renderReact() {
    this.reactRoot && this.reactRoot.render(c.createElement(this.jsx, { ...this.props }));
  }
}
customElements.define("ux-react-web-component", i);
const l = (s, t, e) => (o = {}) => Promise.resolve(new i(s, t, o, e));
export {
  l as wrapReactViewFactory
};
//# sourceMappingURL=index.js.map
